import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { PRIMARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { ICON_POSITION } from '../../../utils/templates';
import Icon from '../../../icon/icon.component';
import { Badge } from '../../../badge/badge.component';

export const TITLE_FONT_NAME = FONT.BERLIN_3;

export const TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const DESCRIPTION_FONT_NAME = FONT.MADRID_1;

export const DESCRIPTION_FONT_TYPE = FONT_TYPE.MAIN;

export const BORDER_COLOR = makeThemeColor(PRIMARY);

export const INNER_BORDER_COLOR = makeThemeColor(TERTIARY);

export const ICONS = {
  [ICON_POSITION.TOP_RIGHT]: 4,
};

export const ICONS_TYPES = {
  [ICON_POSITION.TOP_LEFT]: Icon,
  [ICON_POSITION.TOP_RIGHT]: Badge,
  [ICON_POSITION.BOTTOM_RIGHT]: Icon,
};

export const ITEMS_BY_BREAKPOINTS = {
  general: {
    [HD]: 8,
    [FULL_HD]: 8,
  },
  search: {
    [HD]: 5,
    [FULL_HD]: 5,
  },
};
